<template>
    <v-list-tile>
        <v-dialog v-model="mostrarDialogoFracassar" persistent :max-width="Modal.Processamento.larguraMaxima">
            <v-list-tile-title slot="activator">
                <i class="fas fa-thumbs-down mr-2" aria-hidden="true"/>
                Fracassar
            </v-list-tile-title>

            <modal-alterar-situacao-lote-e-item v-model="lista" :title="'Fracassar'"
                                                @fecharModalAlteracao="tratarEventoFecharModal"
                                                @salvarAlteracaoSituacao="tratarEventoFracassar"/>
        </v-dialog>
    </v-list-tile>
</template>

<script>
import {actionTypes, Modal} from '@/core/constants'
import ModalAlterarSituacaoLoteEItem from '@/views/pages/comprador/execucao-compra-direta/acoes/ModalAlterarSituacaoLoteEItem'

export default {
    name: 'AcoesFracassar',
    components: {ModalAlterarSituacaoLoteEItem},
    props: {
        compraDiretaId: {
            required: true
        }
    },
    data() {
        return {
            lista: {
                itens: [],
                itensDisponiveis: [],
                itensIndisponiveis: [],
                lotes: [],
                lotesDisponiveis: [],
                lotesIndisponiveis: []
            },
            mostrarDialogoFracassar: false,
            Modal
        }
    },
    methods: {
        async buscarResumoItensLotes() {
            this.lista = await this.$store.dispatch(actionTypes.BUSCAR_RESUMO_ITEM_E_LOTE, this.compraDiretaId)
        },
        async tratarEventoFracassar(objModal) {
            const objParaFracassar = {
                compraDiretaId: this.compraDiretaId,
                dados: {
                    itens: objModal.itens,
                    lotes: objModal.lotes,
                    motivo: objModal.motivo,
                    situacao: 'FRACASSADO'
                }
            }
            await this.$store.dispatch(actionTypes.ALTERAR_SITUACAO_DE_ITEM_E_LOTE, objParaFracassar)
            this.mostrarNotificacaoSucesso('Item fracassado com sucesso.')
            this.tratarEventoFecharModal()
        },
        tratarEventoFecharModal() {
            this.mostrarDialogoFracassar = false
            this.lista = {
                itens: [],
                itensDisponiveis: [],
                itensIndisponiveis: [],
                lotes: [],
                lotesDisponiveis: [],
                lotesIndisponiveis: []
            }
        }
    },
    watch: {
        'mostrarDialogoFracassar': {
            async handler(novoValor) {
                if (novoValor) {
                    try {
                        await this.buscarResumoItensLotes()
                    } catch (e) {
                        this.mostrarNotificacaoErro(e.message)
                    }
                }
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-dialog__container
        width 100%
</style>
